import React, { createContext, useContext, useState } from 'react';

const RecruitmentCountsContext = createContext({ counts: {}, setCounts: () => {} });

export function RecruitmentCountsProvider({ children }) {
  const [counts, setCounts] = useState({});
  return <RecruitmentCountsContext.Provider value={{ counts, setCounts }}>{children}</RecruitmentCountsContext.Provider>;
}

export const useRecruitmentCounts = () => useContext(RecruitmentCountsContext);
